import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-modal-option',
    templateUrl: './modal-option.component.html',
    styleUrls: ['./modal-option.component.scss'],
    imports: [NgClass]
})
export class ModalOptionComponent implements OnInit {

  @Input() modalConfig = {
    modalType: 'alert',
    header: 'A message ',
    content: 'bhjdjsdasd adjkajkasd daksjdsajk dasdakskddshdilshdshildsds  dsdsdsdsddsdssqwqwew',
    footerPrimaryBtnLabel: 'OK',
    footerSecondaryBtnLabel: 'second',
    checkMessage: ''
  };

  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() primaryBtnClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() secondaryBtnClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild("closeBtnHeader", { static: true }) modalBtnHeader: ElementRef;
  @ViewChild("antherPrdctBtn", { static: true }) antherPrdctBtn: ElementRef;
  @ViewChild("samePrdctBtn", { static: true }) samePrdctBtn: ElementRef;
  @ViewChild("closeBtn", { static: true }) closeBtnFoc: ElementRef;
  public count: number = 0;

  constructor() { }

  ngOnInit() {
    this.setFocus();
  }

  primaryBtnClickHandler() {
    this.primaryBtnClick.emit(true);
  }

  secondaryBtnClickHandler() {
    this.secondaryBtnClick.emit(true);
  }

  close() {
    this.closeModal.emit(true);
  }

  setFocus() {

    this.modalBtnHeader.nativeElement.focus();
  }
  @HostListener('document:keydown', ['$event']) circulateTabbing(event) {

    if (!(event.shiftKey) && event.keyCode === 9) {
      if (this.count === 0) {
        this.count++;
      } else if (this.count === 4) {
        this.count = 1;
      }

      switch (true) {
        case this.count === 1: this.closeBtnFoc.nativeElement.focus();
          this.count++;
          break;

        case this.count === 2: this.samePrdctBtn.nativeElement.focus();
          this.count++;
          break;

        case this.count === 3: this.antherPrdctBtn.nativeElement.focus();
          this.count++;
          break;


        default: break;
      }

    }

    else if (event.shiftKey && event.keyCode === 9) {


      if (this.count === 0) {
        this.count++;
      } else if (this.count === 4) {
        this.count = 3;
      }


      switch (true) {
        case this.count === 1: this.antherPrdctBtn.nativeElement.focus();
          this.count = 3;
          break;


        case this.count === 2: this.closeBtnFoc.nativeElement.focus();

          this.count--;
          break;

        case this.count === 3: this.samePrdctBtn.nativeElement.focus();

          this.count--;
          break;



        default: break;
      }



    }

  }

}
